module.exports = __webpack_public_path__ + "img/agenda.783fd7ee.png";